module.exports = __webpack_public_path__ + "img/m_role_5_name.453aafc0.png";